<template>
  <div class="header-nav-item relative" @mouseenter="isOpen = true" @mouseleave="isOpen = false">
    <button
      class="header-nav-item__button font-Spectral text-base font-medium leading-[20px] tracking-[0.5px] transition-all duration-300"
      type="button"
      :class="[isOpen ? 'text-gold1' : '', textColorClass]"
    >
      {{ label }}
    </button>
    <Transition name="dropdown">
      <div v-show="isOpen" class="header-nav-item__dropdown fixed left-0 right-0 top-[70px] z-[99]">
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  isWhiteText?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isWhiteText: false,
});

const isOpen = ref(false);

const route = useRoute();
watch(
  () => route.fullPath,
  () => {
    isOpen.value = false;
  },
);

const textColorClass = computed(() => {
  if (props.isWhiteText) {
    return 'text-white hover:text-gold1';
  }
  return 'text-neutral-900 hover:text-gold1';
});
</script>

<style lang="scss" scoped>
.header-nav-item {
  height: 70px;
  display: flex;
  align-items: center;

  &__button {
    position: relative;
    padding: 0 12px;
    background: none;
    border: none;
    cursor: default;
  }
  &:hover &__button {
    text-decoration: underline;
  }

  &__dropdown {
    width: 100vw;
  }
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition:
    opacity 0.2s ease,
    transform 0.2s ease;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
